export default __webpack_public_path__ + "static/media/scdream3.ff172022.woff2";